/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_P2dInputs */

const en_mk_sol_agensi_p2d = /** @type {(inputs: Mk_Sol_Agensi_P2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Writing twelve captions or three ad-headline variants is not hard work, but it still consumes someone who should be thinking about strategy.`)
};

const id_mk_sol_agensi_p2d = /** @type {(inputs: Mk_Sol_Agensi_P2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menulis dua belas caption atau tiga varian judul iklan bukan pekerjaan sulit, tapi tetap memakan waktu orang yang seharusnya memikirkan strategi.`)
};

/**
* | output |
* | --- |
* | "Writing twelve captions or three ad-headline variants is not hard work, but it still consumes someone who should be thinking about strategy." |
*
* @param {Mk_Sol_Agensi_P2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_p2d = /** @type {((inputs?: Mk_Sol_Agensi_P2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_P2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_p2d(inputs)
	return en_mk_sol_agensi_p2d(inputs)
});